import { NavLink, Outlet, Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "@/App";
import {
  LayoutDashboard, Users, MapPin, Gift, DollarSign, Package, Percent,
  Ticket, Shield, MessageCircle, BarChart3, LogOut, ChevronLeft, Mail, Sparkles, Coins, Radio, Image as ImageIcon, Store, Activity,
} from "lucide-react";
import { GlobalFiltersProvider, GlobalFiltersBar } from "./GlobalFilters";

const NAV = [
  { section: "VISÃO GERAL", items: [
    { to: "/admin", label: "Dashboard Executivo", icon: LayoutDashboard, end: true },
    { to: "/admin/analytics", label: "Hermes Analytics", icon: BarChart3 },
  ]},
  { section: "USUÁRIOS", items: [
    { to: "/admin/users", label: "Todos os usuários", icon: Users },
    { to: "/admin/geo", label: "Distribuição geográfica", icon: MapPin },
    { to: "/admin/birthdays", label: "Aniversariantes", icon: Gift },
  ]},
  { section: "FINANCEIRO", items: [
    { to: "/admin/financial", label: "Financeiro", icon: DollarSign },
    { to: "/admin/comercial", label: "Comercial (Billing)", icon: Store },
    { to: "/admin/plans", label: "Planos (legado)", icon: Package },
    { to: "/admin/coupons", label: "Cupons", icon: Ticket },
  ]},
  { section: "ADMINISTRAÇÃO", items: [
    { to: "/admin/audit", label: "Auditoria", icon: Shield },
    { to: "/admin/apis", label: "APIs & Health-check", icon: Activity },
    { to: "/admin/communications", label: "Comunicações", icon: MessageCircle },
    { to: "/admin/templates", label: "Templates", icon: Mail },
    { to: "/admin/intelligence", label: "Inteligência 360", icon: Sparkles },
    { to: "/admin/creditos-mineral", label: "Créditos Mineral", icon: Coins },
    { to: "/admin/djen", label: "DJEN Diagnóstico", icon: Radio },
    { to: "/admin/images", label: "Imagens do Site", icon: ImageIcon },
  ]},
];

export default function AdminLayout() {
  const { user, loading, logout } = useAuth();
  const navigate = useNavigate();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-400 bg-[#0b0f1a]">Carregando…</div>;
  if (!user) return <Navigate to="/" replace />;
  if (!user.is_owner) return <Navigate to="/dashboard" replace />;

  return (
    <div className="min-h-screen flex bg-[#0b0f1a] text-slate-200" data-testid="admin-layout">
      <aside className="w-64 shrink-0 border-r border-white/5 bg-[#0a0d17] flex flex-col">
        <div className="px-5 py-6 border-b border-white/5">
          <div className="flex items-center gap-2 text-[#d4a24c] font-serif text-xl tracking-wide">
            <span className="text-2xl">⚖</span> HERMES
          </div>
          <div className="text-[10px] uppercase tracking-[0.24em] text-slate-500 mt-1">Admin · OWNER</div>
        </div>
        <nav className="flex-1 overflow-y-auto py-4 px-2 text-sm">
          {NAV.map((sec) => (
            <div key={sec.section} className="mb-4">
              <div className="text-[10px] uppercase tracking-[0.22em] text-slate-500 px-3 mb-1">{sec.section}</div>
              {sec.items.map((it) => (
                <NavLink key={it.to} to={it.to} end={it.end}
                  className={({isActive}) =>
                    `flex items-center gap-3 px-3 py-2 rounded-lg transition-colors ${
                      isActive ? "bg-gradient-to-r from-[#3a2a15] to-transparent text-[#d4a24c] border-l-2 border-[#d4a24c]"
                               : "text-slate-300 hover:bg-white/5"
                    }`
                  }
                  data-testid={`admin-nav-${it.to.replace(/\//g,'-')}`}
                >
                  <it.icon className="w-4 h-4" /> <span>{it.label}</span>
                </NavLink>
              ))}
            </div>
          ))}
        </nav>
        <div className="p-3 border-t border-white/5 flex flex-col gap-1">
          <button onClick={() => navigate("/dashboard")}
            className="w-full text-left flex items-center gap-2 px-3 py-2 rounded-lg text-slate-300 hover:bg-white/5"
            data-testid="admin-back-app">
            <ChevronLeft className="w-4 h-4" /> Voltar ao Hermes
          </button>
          <button onClick={logout}
            className="w-full text-left flex items-center gap-2 px-3 py-2 rounded-lg text-slate-300 hover:bg-white/5"
            data-testid="admin-logout">
            <LogOut className="w-4 h-4" /> Sair
          </button>
        </div>
      </aside>
      <main className="flex-1 min-w-0 overflow-y-auto">
        <GlobalFiltersProvider>
          <GlobalFiltersBar />
          <Outlet />
        </GlobalFiltersProvider>
      </main>
    </div>
  );
}
